// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2oiVe","col":"styles_col__3R4Ke"};